export enum HelpSubject{
    CustomerService = "customerService",
    TechnicalSupport = "technicalSupport",
    ContentSuggestions = "contentSuggestion",
    Careers = "careers",
    Other = "other"
}